import React from 'react';

const DescriptionPanel = () => {
    return (
        <div className="description-panel">
            <h1>Free Temp Email</h1>
            
            <div className="feature-highlight">
                <p className="main-description">
                    ✨ Instant Temp Mail &nbsp;|&nbsp; 
                    🔒 100% Private &nbsp;&nbsp;|&nbsp;
                    🛡️ Spam Protected
                </p>
            </div>

            <div className="usage-info">
                <h3>Simple & Secure Temporary Email</h3>
                <p>
                    Get an instant disposable email for your online activities. 
                    Our temp mail is perfect for sign-ups, downloads, and keeping your inbox clean. 
                    No registration needed.
                </p>
            </div>

            <div className="steps">
                <p>Generate → Receive → Dispose</p>
                <p className="note">Free Temp Mail • No Sign-up • Instant Access</p>
            </div>
        </div>
    );
};

export default DescriptionPanel; 